import { IAppState } from 'src/app/redux/store/reducers';

export const getClientHeader = (state: IAppState): string => state.layout.clientHeader;
export const getCompanyHeader = (state: IAppState): string => state.layout.companyHeader;
export const getProjectHeader = (state: IAppState): string => state.layout.projectHeader;
export const getTeamHeader = (state: IAppState): string => state.layout.teamHeader;
export const getSsoSchemaTeamHeader = (state: IAppState): string => state.layout.ssoSchemaHeader;
